export const SinAsignar = () => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.3054 0.0215734C9.94524 -0.145371 -0.145371 9.94524 0.0215734 22.3054C0.186404 34.1595 9.83852 43.8117 21.6926 43.9765C34.0549 44.1455 44.1434 34.0549 43.9744 21.6947C43.8117 9.83852 34.1595 0.186404 22.3054 0.0215734ZM35.6631 34.5991C35.621 34.6446 35.5694 34.6803 35.512 34.7037C35.4546 34.727 35.3927 34.7374 35.3308 34.7342C35.2689 34.731 35.2084 34.7142 35.1538 34.685C35.0991 34.6558 35.0515 34.6149 35.0143 34.5653C34.0693 33.3288 32.9119 32.2701 31.5962 31.4388C28.9061 29.7123 25.4975 28.7613 21.999 28.7613C18.5006 28.7613 15.092 29.7123 12.4019 31.4388C11.0862 32.2698 9.92886 33.3281 8.98373 34.5642C8.9466 34.6139 8.899 34.6547 8.84431 34.6839C8.78962 34.7131 8.72918 34.7299 8.66727 34.7332C8.60536 34.7364 8.5435 34.726 8.48607 34.7026C8.42865 34.6792 8.37706 34.6435 8.33497 34.598C5.23454 31.2511 3.47826 26.8777 3.40272 22.316C3.23049 12.0342 11.6675 3.42808 21.9536 3.40272C32.2397 3.37736 40.5953 11.7299 40.5953 21.999C40.5989 26.6707 38.8372 31.1713 35.6631 34.5991Z"
        fill="#DCE6E6"
      />
      <path
        d="M21.9982 10.166C19.9146 10.166 18.0306 10.9469 16.6919 12.3659C15.3532 13.7849 14.6844 15.747 14.8355 17.8528C15.1419 22 18.355 25.3812 21.9982 25.3812C25.6414 25.3812 28.8482 22 29.161 17.8539C29.3173 15.7682 28.6538 13.824 27.2929 12.3786C25.9489 10.9521 24.0681 10.166 21.9982 10.166Z"
        fill="#DCE6E6"
      />
    </svg>
  );
};
